import { ReactNode, MouseEvent } from "react";
import { Button } from "./components/ui/button"

interface ButtonIconProps {
    children: ReactNode;
    icon: ReactNode;
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    variant?: "default" | "secondary" | "link" | "outline" | "destructive" | "ghost";
    className?: string;
}

export const ButtonIcon = ({ children, icon, onClick, variant = 'default', className = '' }: ButtonIconProps) => {
    return (
        <Button className={`cursor-pointer ${className}`} onClick={onClick} variant={variant}>
            <span className="flex shrink-0 items-center [&_svg]:h-4 [&_svg]:w-4">{icon}</span>
            {children}
        </Button>
    )
};